import { isValidCellValue } from '@components/data-display/table/utils/helpers/cells/is-valid-cell-value';
import { ValueType } from '@components/data-entry/input/helpers/is-value-type';

export const getCellInputValue = (value: unknown): ValueType | undefined => {
  return isValidCellValue(value) ? value ?? undefined : undefined;
};
